export default __webpack_public_path__ + "static/media/ICL_logo.7fa66d41.svg";